import { render, staticRenderFns } from "./ProblemForm.vue?vue&type=template&id=47b07ad8"
import script from "./ProblemForm.vue?vue&type=script&lang=js"
export * from "./ProblemForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports